<template>
  <div class="container">
    <div class="container">
      <div class="row g-4">
        <div
          class="col-12 col-md-6 d-flex"
          v-for="item in data"
          :key="item.id"
        >
          <contactTemplate :data="item" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactTemplate from "../share/ContactTemplate.vue";

export default {
  components: { contactTemplate },

  data() {
    return {
      data: [],
    };
  },

  mounted() {
    this.data = this.getAllData(); // injoron subdomain-in
  },

  methods: {
    getAllData() {
      const allData = {
        pthprishtine: [
          {
            id: 2,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthprishtine.care.cardright.title")
              ? this.$t("menus.pthprishtine.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthprishtine.care.cardright.tel1")
              ? this.$t("menus.pthprishtine.care.cardright.tel1")
              : null,
          },
        ],
        pthprizren: [
          {
            id: 3,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthprizren.care.cardright.title")
              ? this.$t("menus.pthprizren.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthprizren.care.cardright.tel1")
              ? this.$t("menus.pthprizren.care.cardright.tel1")
              : null,
          },
        ],
        pthferizaj: [
          {
            id: 4,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthferizaj.care.cardright.title")
              ? this.$t("menus.pthferizaj.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthferizaj.care.cardright.tel1")
              ? this.$t("menus.pthferizaj.care.cardright.tel1")
              : null,
          },
        ],
        pthpeje: [
          {
            id: 5,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthpeje.care.cardright.title")
              ? this.$t("menus.pthpeje.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthpeje.care.cardright.tel1")
              ? this.$t("menus.pthpeje.care.cardright.tel1")
              : null,
          },
        ],
        pthmitrovice: [
          {
            id: 6,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthmitrovice.care.cardright.title")
              ? this.$t("menus.pthmitrovice.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthmitrovice.care.cardright.tel1")
              ? this.$t("menus.pthmitrovice.care.cardright.tel1")
              : null,
          },
        ],
        pthgjilan: [
          {
            id: 7,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthgjilan.care.cardright.title")
              ? this.$t("menus.pthgjilan.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthgjilan.care.cardright.tel1")
              ? this.$t("menus.pthgjilan.care.cardright.tel1")
              : null,
          },
        ],
        pthgjakove: [
          {
            id: 8,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthgjakove.care.cardright.title")
              ? this.$t("menus.pthgjakove.care.cardright.title")
              : null,
            tel1: this.$te("menus.pthgjakove.care.cardright.tel1")
              ? this.$t("menus.pthgjakove.care.cardright.tel1")
              : null,
          },
        ],
      };

      // bashkon të gjitha array-t në një të vetëm
      return Object.values(allData).flat();
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 48px;
  padding-bottom: 48px;
  margin-bottom: 0 !important;
}
</style>
